import { getBottomOriginItemStyle } from '../../../layout-geometry';
import { ModuleLayoutItemProps } from './module-layout-item.component';

interface ViewProps {
    style: React.CSSProperties;
    label?: string;
    divClassName: string;
    spanClassName: string;
}

export const moduleLayoutItemDivClass = 'border border-secondary';
export const moduleLayoutItemSpanClass = '';
const useModuleLayoutItem = (props: ModuleLayoutItemProps): ViewProps => {
    const divClassName = props.styles?.div
        ? typeof props.styles?.div === 'function'
            ? props.styles?.div(props.module, props.slotRendering)
            : props.styles?.div
        : moduleLayoutItemDivClass;
    const spanClassName = props.styles?.span
        ? typeof props.styles?.span === 'function'
            ? props.styles?.span(props.module, props.slotRendering)
            : props.styles?.span
        : moduleLayoutItemSpanClass;
    const label = typeof props.label === 'function' ? props.label(props.module, props.slotRendering) : props.label;
    const style = getBottomOriginItemStyle({
        x: props.module.location.x,
        y: props.module.location.y,
        width: props.module.dimension.width,
        height: props.module.dimension.height,
        minX: props.minX,
        maxY: props.maxY,
        scale: props.scale,
        overflow: 'visible'
    });

    return {
        style,
        label,
        divClassName,
        spanClassName
    };
};

export default useModuleLayoutItem;
